import { Heading, PostItem } from "../../components";
import React from "react";

const postsList = [
  {
    headingText:
      "Understanding and Achieving the Break-Even Point (BEP) in Restaurants",
    descriptionText:
      "The financial success of a restaurant hinges on understanding key metrics, with the break-even point (BEP) being critical. BEP is when total revenue matches total costs, and every sale beyond it generates profit. Achieving BEP requires tracking fixed and variable costs, setting profitable menu prices, driving revenue through sales strategies, and improving operational efficiency by minimizing waste and optimizing inventory.",
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
    slug: "breakeven",
  },
  {
    headingText: "The Importance of Instagram for Restaurants",
    descriptionText:
      "With 77% of diners checking a restaurant’s Instagram before visiting, your profile serves as a crucial first impression. Make it captivating by showcasing your best dishes with enticing photos, sharing customer experiences through user-generated content (UGC), and keeping your bio clear and engaging.",
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
    slug: "social",
  },
  {
    headingText: "Tracking ROI on Restaurant Marketing Campaigns",
    descriptionText:
      "Forecasting and tracking ROI on marketing spend is essential for restaurant owners to identify the most effective channels, minimize overspending, and measure marketing success. Start by calculating the total cost of the campaign (e.g., ads, influencer fees, discounts, and production costs). Track revenue directly linked to the campaign using sales data, promo codes, or referred customer metrics. Determine net profit by subtracting campaign costs from total revenue, then calculate ROI using the formula: ROI = (Net Profit / Cost of Campaign) × 100.",
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
    slug: "marketing_roi",
  },
  {
    headingText: "Key Factors to Consider when Launching Delivery Service",
    descriptionText:
      "When launching a delivery service, key factors to consider include setting a clear delivery time goal (e.g., 45 minutes), factoring in food preparation time, and estimating average travel speed based on urban or suburban conditions. Prioritize service quality by ensuring food arrives fresh, using proper packaging, and accounting for delays like traffic or weather. Ensure adequate driver availability to meet delivery times, and focus on high customer density areas to optimize routes and efficiency.",
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
    slug: "delivery_service",
  },
  {
    headingText: "Tools to Help while offering Delivery Service",
    descriptionText:
      "To enhance delivery service, use mapping software like Google Maps to plan delivery areas and monitor traffic. Leverage delivery platform analytics (e.g., Talabat or Zyda) for insights on delivery times and customer density. Additionally, track customer feedback on delivery time and food quality to refine your service radius.",
    likeIconImage: "images/img_heart_rounded.svg",
    likeCountText: "30",
    commentCountText: "100",
    shareCountText: "50",
    slug: "tools",
  },
];

export default function PostsSection() {
  return (
    <>
      {/* posts section */}
      <div className="flex flex-col items-center">
        <div className="container-sm flex flex-col gap-2 lg:px-5 md:px-5">
          <div className="flex items-center justify-between gap-5">
            <Heading
              as="h1"
              className="sm:text-[18px] font-bold tracking-[0.15px] lg:text-[13px]"
            >
              Posts
            </Heading>
          </div>
          <div className="mr-[768px] flex gap-2 overflow-x-auto md:mr-0 md:flex-col sm:flex-row sm:items-start sm:justify-start">
            {postsList.map((d, index) => (
              <PostItem {...d} key={"listuserOne" + index} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
